var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from './Icon';
import * as Styled from './ButtonIcon.styled';
/**
 * A special button component to render icons
 */
var ButtonIcon = function (_a) {
    var _b = _a.name, name = _b === void 0 ? 'close' : _b, _c = _a.isRounded, isRounded = _c === void 0 ? false : _c, _d = _a.children, children = _d === void 0 ? undefined : _d, _e = _a.iconPosition, iconPosition = _e === void 0 ? 'right' : _e, _f = _a.iconSize, iconSize = _f === void 0 ? 'inherit' : _f, _g = _a.img, img = _g === void 0 ? undefined : _g, _h = _a.alt, alt = _h === void 0 ? undefined : _h, rest = __rest(_a, ["name", "isRounded", "children", "iconPosition", "iconSize", "img", "alt"]);
    return (React.createElement(Styled.ButtonIcon, __assign({ isRounded: isRounded, iconPosition: iconPosition, hasText: !!children, enabledPseudoclass: false }, rest),
        children && (React.createElement(Styled.Text, { iconPosition: iconPosition }, children)),
        img ? (React.createElement("img", { src: img, alt: alt, height: "20" })) : (React.createElement(Icon, { "data-name": name, name: name, size: iconSize }))));
};
export default ButtonIcon;
